// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 549) return "static/css/549.aa1b56154f1121f21945.css";
	// return url for filenames based on template
	return undefined;
};